// extracted by mini-css-extract-plugin
module.exports = {"form":"AuthForm_form__6K0LV","authButton":"AuthForm_authButton__1gfuw","divider":"AuthForm_divider__1z9Tx","footer":"AuthForm_footer__3eh57"};